module.exports = "<div  class=\"absolute-center-flex flex-column empty-message\">\n    <span ng-class=\"ctrl.imageClass? '{{ctrl.imageClass}}': 'icon-empty-list'\" class=\"empty-message__icon mb6\"></span>\n    <span ng-if=\"ctrl.titleMessage\"\n          ng-bind=\"ctrl.titleMessage\"\n          class=\"empty-message__text-top\">\n    </span>\n    <span ng-if=\"ctrl.message\"\n          ng-bind=\"ctrl.message\"\n          class=\"empty-message__text-bottom\">\n    </span>\n</div>\n\n";


//////////////////
// WEBPACK FOOTER
// ./src/app.common/modules/common/components/empty-list-state/empty-list-state.component.html
// module id = 625
// module chunks = 6